import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Grid,
  IconButton,
  Paper,
  styled,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useMemo, useEffect } from "react";

import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ConnectedCallTable from "./ConnectedCallTable";
import NotConnectedCallTable from "./NotConnectedCallTable";

// FancyCard (Styled Paper)
const FancyCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.primary.light,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
  marginBottom: theme.spacing(2),
  textAlign: "center",
}));

// InfoBox (Styled Box for task info)
const InfoBox = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  padding: theme.spacing(1),
  backgroundColor: theme.palette.secondary.main,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  display: "inline-block",
  width: "100%",
  textAlign: "center",
}));

const ExpandIcon = styled(IconButton)(({ theme, expand }) => ({
  transform: expand ? "rotate(180deg)" : "rotate(0deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const DataDisplayCard = ({
  filters,
  setFilters,
  agentName,
  setLoading
}) => {
  const [isExpanded, setIsExpanded] = useState(true); // Single card starts expanded
// const [loading, setLoading] = useState(false);
  const handleExpandClick = () => {
    setIsExpanded((prev) => !prev); // Toggle the expanded state
  };

  const [tabValues, setTabValues] = useState(0); // Object to track each card's tab state

  const handleTabChange = (index, newValue) => {
    setTabValues(newValue);
  };

  const [callStatistics, setCallStatistics] = useState([]);
    const [metricData, setMetricData] = useState([]);

  return (
    <>
      {/* Data Display */}
      <Grid container spacing={2} sx={{ padding: 2 }}>
        <Grid item xs={12} key={agentName}>
          <Card
            sx={{
              boxShadow: 3,
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <CardHeader
              title={
                <div>
                  <Grid container spacing={2} sx={{ marginTop: "-4px" }}>
                    <Grid item xs={12} sm={4}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {agentName}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid
                          item
                          xs={6}
                          sm={3}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <InfoBox
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "6px 12px", // Adjust padding for better spacing
                              backgroundColor: "#f5f5f5",
                              // border: '2px #9c27b0 solid',
                              borderRadius: "8px",
                              width: "100%",
                            }}
                          >
                            <Typography
                              variant="caption"
                              color="black"
                              sx={{ fontWeight: "bold" }}
                            >
                              Total
                            </Typography>
                            <Typography
                              variant="body2"
                              color="#2196f3"
                              sx={{ fontWeight: "bold" }}
                            >
                              {metricData.totalCalls}
                            </Typography>
                          </InfoBox>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          sm={3}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <InfoBox
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "6px 12px", // Adjust padding for better spacing
                              backgroundColor: "#f5f5f5",
                              // border: '2px #FF8C00 solid',
                              borderRadius: "8px",
                              width: "100%",
                            }}
                          >
                            <Typography
                              variant="caption"
                              color="black"
                              sx={{ fontWeight: "bold" }}
                            >
                              Connected
                            </Typography>
                            <Typography
                              variant="body2"
                              color="#FF8C00"
                              sx={{ fontWeight: "bold" }}
                            >
                              {metricData.connectedCalls}
                            </Typography>
                          </InfoBox>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          sm={3}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <InfoBox
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "6px 12px", // Adjust padding for better spacing
                              backgroundColor: "#f5f5f5",
                              // border: '2px solid #4caf50' ,
                              borderRadius: "8px",
                              width: "100%",
                            }}
                          >
                            <Typography
                              variant="caption"
                              color="black"
                              sx={{ fontWeight: "bold" }}
                            >
                              Connected Rate
                            </Typography>
                            <Typography
                              variant="body2"
                              color="#4caf50"
                              sx={{ fontWeight: "bold" }}
                            >
                              {metricData.connectionRate}
                            </Typography>
                          </InfoBox>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          sm={3}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <InfoBox
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "6px 12px", // Adjust padding for better spacing
                              backgroundColor: "#f5f5f5",
                              // border: '2px solid #e53935',
                              borderRadius: "8px",
                              width: "100%",
                            }}
                          >
                            <Typography
                              variant="caption"
                              color="black"
                              sx={{ fontWeight: "bold" }}
                            >
                              Not-Connected
                            </Typography>
                            <Typography
                              variant="body2"
                              color="#e53935"
                              sx={{ fontWeight: "bold" }}
                            >
                              {metricData.missedCalls}
                            </Typography>
                          </InfoBox>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              }
              action={
                <ExpandIcon expand={isExpanded} onClick={handleExpandClick}>
                  <ExpandMoreIcon />
                </ExpandIcon>
              }
              sx={{
                backgroundColor: "#f5f5f5",
                borderBottom: "1px solid #e0e0e0",
                padding: "0px 12px", // Reduced padding to make header smaller
                height: "auto", // Ensures the header height adjusts dynamically based on content
                "& .MuiCardHeader-action": {
                  marginTop: "5px",
                },
              }}
            />
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <CardContent sx={{ paddingTop: 0 }}>
                <Tabs
                  value={tabValues || 0} // Default to 0 if not set
                  onChange={handleTabChange}
                  aria-label="wrapped label tabs example"
                >
                  <Tab
                    label={`Connected (${metricData.connectedCalls || 0})`}
                    id={`tab-0`}
                    iconPosition="start"
                    aria-controls={`tabpanel-0`}
                  />
                  <Tab
                    label={`Not-Connected (${metricData.missedCalls || 0})`}
                    id={`tab-1`}
                    iconPosition="start"
                    aria-controls={`tabpanel-1`}
                  />
                </Tabs>

                <TabPanel value={tabValues || 0} index={0}>
                  <ConnectedCallTable  filters={filters} setFilters={setFilters} setMetricData={setMetricData} setLoading={setLoading} />
                </TabPanel>
                <TabPanel value={tabValues || 0} index={1}>
                  <NotConnectedCallTable  filters={filters} setFilters={setFilters} setMetricData={setMetricData} setLoading={setLoading} />
                </TabPanel>
              </CardContent>
            </Collapse>
          </Card>
        </Grid>
      
      </Grid>
    </>
  );
};

export default DataDisplayCard;
